// extracted by mini-css-extract-plugin
export default {"button":"SubmitButton_button__eweLp","submitting":"SubmitButton_submitting__mxUu9","loading":"SubmitButton_loading__atfk3"};